import { NavLink } from "react-router-dom";

import logo from "../assets/ecotrans-logo.png";

import { FaFacebookF, FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const navLinkClass = ({ isActive }) =>
    `pb-2 border-b-2 transition-all duration-300 ${
      isActive
        ? "border-green text-green"
        : "border-transparent hover:border-green"
    }`;

  return (
    <footer className="bg-dark text-light py-20">
      <div className="container mx-auto px-6 md:px-20">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-14">
          <div className="flex justify-center md:justify-start">
            <NavLink to="/">
              <img
                className="h-14 w-40 object-contain"
                src={logo}
                alt="ecotrans"
              />
            </NavLink>
          </div>

          <div>
            <ul className="flex flex-col gap-5 text-light font-light items-center md:items-end xl:items-start">
              <li>
                <NavLink className={navLinkClass} to="/">
                  {t("home")}
                </NavLink>
              </li>

              <li>
                <NavLink className={navLinkClass} to="/about">
                  {t("about")}
                </NavLink>
              </li>

              <li>
                <NavLink className={navLinkClass} to="/services">
                  {t("services")}
                </NavLink>
              </li>

              <li>
                <NavLink className={navLinkClass} to="/contact">
                  {t("contact")}
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-2.5 md:gap-6 items-center md:items-start">
            <a
              href="tel:+995577092645"
              className="flex items-center gap-4 text-light hover:text-green transition-all duration-300"
            >
              <FaPhoneAlt className="text-base" />

              <span className="text-base">+995 577 092 645</span>
            </a>

            <a
              href="mailto:ecotransgeorgia@gmail.com"
              className="flex items-center gap-4 text-light hover:text-green transition-all duration-300"
            >
              <MdEmail className="text-xl" />

              <span className="text-base">ecotransgeorgia@gmail.com</span>
            </a>
          </div>

          <div className="flex flex-col items-center md:items-end">
            <h3 className="text-base mb-16 md:mb-5 xl:mb-16">{t("follow")}:</h3>

            <div className="flex items-center gap-6">
              <NavLink
                to="https://www.facebook.com/"
                target="_blank"
                className="text-light hover:text-green transition-all duration-300"
              >
                <FaFacebookF className="text-xl" />
              </NavLink>

              <NavLink
                to="https://www.instagram.com/"
                target="_blank"
                className="text-light hover:text-green transition-all duration-300"
              >
                <FaInstagram className="text-[26px]" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
